// internal-deps
import { Option, Some, None } from "@swiggy-private/js-fp";
import { PaymentMethod, PaymentMethodMeta, generatePaymentMethodId } from "@swiggy-private/payment-ui";
import { isEmpty } from "@swiggy-private/js-utils";

// interfaces
import { GetPaymentMethodsResponse } from "@payment-client/interfaces/PaymentApi";

export const getPaymentMethodIdToAutoSelect = (
    paymentResponse?: GetPaymentMethodsResponse | null,
    frictionGroupName?: string,
): Option<string> => {
    if (isEmpty(paymentResponse)) {
        return None;
    }

    const frictionGroup = paymentResponse?.paymentGroup?.find?.(
        (group) => group.groupName?.toUpperCase() === frictionGroupName?.toUpperCase() && group.enabled,
    );

    if (isEmpty(frictionGroup)) {
        return None;
    }

    const paymentMethodToAutoSelect = frictionGroup?.paymentMethods?.find?.(
        (method) => method?.meta?.isSelected && method?.enabled,
    );

    if (isEmpty(paymentMethodToAutoSelect)) {
        return None;
    }

    return Some(generatePaymentMethodId(paymentMethodToAutoSelect as PaymentMethod<PaymentMethodMeta>));
};
